import { useState } from "react";
import { useLang } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Plus, X } from "lucide-react";

export function MemberSection({ title, items, refMap, available, onAdd, onRemove, idKey, testid, emptyMsg, readOnly }) {
  const { t } = useLang();
  const [pick, setPick] = useState("");
  return (
    <div className="border border-zinc-200 bg-white" data-testid={testid}>
      <div className="border-b border-zinc-200 bg-zinc-50 px-4 py-2.5 text-xs font-bold uppercase tracking-[0.15em] text-zinc-600">
        {title}
      </div>
      <div className="space-y-2 p-4">
        {items.length === 0 && <div className="text-sm text-zinc-400">{emptyMsg}</div>}
        {items.map((id) => (
          <div key={id} className="flex items-center justify-between border border-zinc-200 px-3 py-2">
            <div className="min-w-0">
              <div className="truncate text-sm font-medium text-zinc-800">{refMap[id]?.displayName || id}</div>
              <div className="truncate font-mono text-[11px] text-zinc-400">{id}</div>
            </div>
            {!readOnly && (
              <button
                onClick={() => onRemove(id)}
                data-testid={`${testid}-remove-${id}`}
                className="p-1.5 text-zinc-400 transition-colors hover:bg-red-50 hover:text-red-600"
                aria-label={t("det.remove")}
              >
                <X size={15} />
              </button>
            )}
          </div>
        ))}
        {!readOnly && (
        <div className="flex gap-2 pt-1">
          <Select value={pick} onValueChange={setPick}>
            <SelectTrigger className="rounded-sm border-zinc-300" data-testid={`${testid}-select`}>
              <SelectValue placeholder={t("det.add")} />
            </SelectTrigger>
            <SelectContent>
              {available.length === 0 && <div className="px-3 py-2 text-sm text-zinc-400">{t("det.nothingToAdd")}</div>}
              {available.map((a) => (
                <SelectItem key={a[idKey]} value={a[idKey]}>{a.displayName}</SelectItem>
              ))}
            </SelectContent>
          </Select>
          <Button
            type="button"
            disabled={!pick}
            onClick={() => { onAdd(pick); setPick(""); }}
            data-testid={`${testid}-add`}
            className="rounded-sm bg-primary px-3 hover:bg-[#002480]"
          >
            <Plus size={16} />
          </Button>
        </div>
        )}
      </div>
    </div>
  );
}
